export function escapeRegex(value: string) {
  return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
}

const regexRulePattern = /^\/(.+)\/i?$/;

/**
 * Whether a rule string uses the slash-wrapped regular expression syntax,
 * e.g. "/^[a-z]+\d+@intractive\.app$/". An optional trailing "i" flag is accepted
 * but has no effect: rules always compile case-insensitively.
 */
export function isRegexRule(value: string): boolean {
  return regexRulePattern.test(value.trim());
}

/**
 * Parse a slash-wrapped rule into a case-insensitive RegExp.
 * Returns undefined when the value is not slash-wrapped or the pattern
 * does not compile.
 */
export function parseRegexRule(value: string): RegExp | undefined {
  const pattern = regexRulePattern.exec(value.trim())?.[1];
  if (!pattern) return undefined;

  try {
    return new RegExp(pattern, "i");
  } catch {
    return undefined;
  }
}
